import React from 'react';
import PropTypes from 'prop-types';

export function DownloadZipIcon() {
  return (
    <svg
      width="0.972vw"
      height="0.972vw"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.12158 4.54688H4.76611V5.12656H5.12158C5.22275 5.12656 5.29932 5.09922 5.35127 5.04453C5.40322 4.98984 5.42783 4.92148 5.42783 4.83945C5.42783 4.75742 5.40322 4.68633 5.35127 4.63164C5.29932 4.57422 5.22275 4.54688 5.12158 4.54688Z"
        fill="#2179C4"
      />
      <path
        d="M6.96182 5.14609C6.96182 4.3668 6.37119 3.73516 5.64111 3.73516H1.00635V6.55977H5.64111C6.37119 6.55977 6.96182 5.92539 6.96182 5.14609ZM3.42353 5.96641H2.26963V5.79688L3.0708 4.54727H2.2751V4.32852H3.39346V4.49258L2.58955 5.75039H3.42353V5.96641ZM4.05518 5.96641H3.78174V4.32578H4.05518V5.96641ZM5.12158 5.3457H4.76611V5.96641H4.49268V4.32578H5.12158C5.30205 4.32578 5.44424 4.37227 5.54814 4.46523C5.65205 4.5582 5.70127 4.68125 5.70127 4.83437C5.70127 4.9875 5.64932 5.11055 5.54814 5.20352C5.44424 5.29922 5.30205 5.3457 5.12158 5.3457ZM10.2103 0.970703H12.1435V1.21953H10.2103V0.970703ZM12.1407 0.344531C12.1407 0.246094 12.0614 0.164062 11.9603 0.164062H10.3907C10.2923 0.164062 10.2103 0.246094 10.2103 0.344531V0.721875H12.1407V0.344531ZM12.9747 3.02422C12.9446 2.96133 12.8817 2.92305 12.8134 2.92305H12.1407V1.46562H10.2075V2.92305H9.5376C9.46924 2.92305 9.40635 2.96133 9.37627 3.02422C9.34619 3.08711 9.35439 3.16094 9.39541 3.21289L11.0333 5.31562C11.0661 5.35938 11.1208 5.38398 11.1755 5.38398C11.2302 5.38398 11.2849 5.35938 11.3177 5.31562L12.9556 3.21289C12.9966 3.1582 13.0048 3.08437 12.9747 3.02422Z"
        fill="#2179C4"
      />
      <path
        d="M10.7325 5.55312L9.09463 3.45039C8.96338 3.28086 8.93877 3.04844 9.03447 2.85703C9.12744 2.66562 9.32705 2.54258 9.54033 2.54258H9.83018V1.10156H2.33799C1.60244 1.10156 1.00635 1.69766 1.00635 2.4332V3.35742H5.64111C6.58174 3.35742 7.34463 4.16133 7.34463 5.15117C7.34463 6.14102 6.579 6.94492 5.64111 6.94492H1.00635V12.5066C1.00635 13.2422 1.60244 13.8383 2.33799 13.8383H9.84385C10.5794 13.8383 11.1755 13.2422 11.1755 12.5066V5.77187C11.0005 5.77187 10.8392 5.69258 10.7325 5.55312Z"
        fill="#2179C4"
      />
    </svg>
  );
}
export function AddCommentIcon() {
  return (
    <svg
      width="0.972vw"
      height="0.972vw"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.91675 1.16406H4.08342C2.47341 1.16406 1.16675 2.4649 1.16675 4.06906V7.5574V8.14073C1.16675 9.7449 2.47341 11.0457 4.08342 11.0457H4.95842C5.11592 11.0457 5.32592 11.1507 5.42508 11.2791L6.30008 12.4399C6.68508 12.9532 7.31508 12.9532 7.70008 12.4399L8.57508 11.2791C8.68591 11.1332 8.86092 11.0457 9.04175 11.0457H9.91675C11.5267 11.0457 12.8334 9.7449 12.8334 8.14073V4.06906C12.8334 2.4649 11.5267 1.16406 9.91675 1.16406ZM7.58342 8.01823H4.08342C3.84425 8.01823 3.64591 7.8199 3.64591 7.58073C3.64591 7.34156 3.84425 7.14323 4.08342 7.14323H7.58342C7.82258 7.14323 8.02092 7.34156 8.02092 7.58073C8.02092 7.8199 7.82258 8.01823 7.58342 8.01823ZM9.91675 5.10156H4.08342C3.84425 5.10156 3.64591 4.90323 3.64591 4.66406C3.64591 4.4249 3.84425 4.22656 4.08342 4.22656H9.91675C10.1559 4.22656 10.3542 4.4249 10.3542 4.66406C10.3542 4.90323 10.1559 5.10156 9.91675 5.10156Z"
        fill="#2179C4"
      />
    </svg>
  );
}
export function CommentOutlineIcon() {
  return (
    <svg
      width="1.667vw"
      height="1.667vw"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 19H8C4 19 2 18 2 13V8C2 4 4 2 8 2H16C20 2 22 4 22 8V13C22 17 20 19 16 19H15.5C15.19 19 14.89 19.15 14.7 19.4L13.2 21.4C12.54 22.28 11.46 22.28 10.8 21.4L9.3 19.4C9.14 19.18 8.77 19 8.5 19Z"
        stroke="#2179C4"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7 8H17"
        stroke="#2179C4"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7 13H13"
        stroke="#2179C4"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
export function BoldDarkIcon() {
  return (
    <svg
      width="1.389vw"
      height="1.389vw"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 3.33594H11.6667C12.5507 3.33594 13.3986 3.68713 14.0237 4.31225C14.6488 4.93737 15 5.78522 15 6.66927C15 7.55333 14.6488 8.40117 14.0237 9.02629C13.3986 9.65141 12.5507 10.0026 11.6667 10.0026H5V3.33594Z"
        stroke="#333333"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5 10H12.5C13.3841 10 14.2319 10.3512 14.857 10.9763C15.4821 11.6014 15.8333 12.4493 15.8333 13.3333C15.8333 14.2174 15.4821 15.0652 14.857 15.6904C14.2319 16.3155 13.3841 16.6667 12.5 16.6667H5V10Z"
        stroke="#333333"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
export function ItalicIconNew() {
  return (
    <svg
      width="1.389vw"
      height="1.389vw"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8333 3.33594H8.33325"
        stroke="#333333"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.6667 16.6641H4.16675"
        stroke="#333333"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.5 3.33594L7.5 16.6693"
        stroke="#333333"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
export function LinkIconNew() {
  return (
    <svg
      width="1.389vw"
      height="1.389vw"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.50008 14.1693H5.83341C4.72835 14.1693 3.66854 13.7303 2.88714 12.9489C2.10573 12.1675 1.66675 11.1077 1.66675 10.0026C1.66675 8.89754 2.10573 7.83773 2.88714 7.05633C3.66854 6.27492 4.72835 5.83594 5.83341 5.83594H7.50008"
        stroke="#333333"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.5 5.83594H14.1667C15.2717 5.83594 16.3315 6.27492 17.1129 7.05633C17.8943 7.83773 18.3333 8.89754 18.3333 10.0026C18.3333 11.1077 17.8943 12.1675 17.1129 12.9489C16.3315 13.7303 15.2717 14.1693 14.1667 14.1693H12.5"
        stroke="#333333"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.66675 10H13.3334"
        stroke="#333333"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
export function LinkInProgress() {
  return (
    <svg
      width="1.25vw"
      height="1.25vw"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.43 17.0625H6.56999C5.15249 17.0625 4.11749 16.47 3.71999 15.45C3.30749 14.385 3.68999 13.065 4.67999 12.1725L8.15999 9L4.67999 5.8275C3.68999 4.935 3.30749 3.615 3.71999 2.55C4.11749 1.5225 5.15249 0.9375 6.56999 0.9375H11.43C12.8475 0.9375 13.8825 1.53 14.28 2.55C14.6925 3.615 14.31 4.935 13.32 5.8275L9.83999 9L13.3275 12.1725C14.31 13.065 14.7 14.385 14.2875 15.45C13.8825 16.47 12.8475 17.0625 11.43 17.0625ZM8.99999 9.7575L5.43749 12.9975C4.80749 13.575 4.52999 14.415 4.76999 15.0375C4.99499 15.615 5.63249 15.9375 6.56999 15.9375H11.43C12.3675 15.9375 13.005 15.6225 13.23 15.0375C13.47 14.415 13.2 13.575 12.5625 12.9975L8.99999 9.7575ZM6.56999 2.0625C5.63249 2.0625 4.99499 2.3775 4.76999 2.9625C4.52999 3.585 4.79999 4.425 5.43749 5.0025L8.99999 8.2425L12.5625 5.0025C13.1925 4.425 13.47 3.585 13.23 2.9625C13.005 2.385 12.3675 2.0625 11.43 2.0625H6.56999Z"
        fill="#F88A31"
      />
    </svg>
  );
}
export function DoneIcon() {
  return (
    <svg
      width="1.25vw"
      height="1.25vw"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 17.0625C4.5525 17.0625 0.9375 13.4475 0.9375 9C0.9375 4.5525 4.5525 0.9375 9 0.9375C13.4475 0.9375 17.0625 4.5525 17.0625 9C17.0625 13.4475 13.4475 17.0625 9 17.0625ZM9 2.0625C5.175 2.0625 2.0625 5.175 2.0625 9C2.0625 12.825 5.175 15.9375 9 15.9375C12.825 15.9375 15.9375 12.825 15.9375 9C15.9375 5.175 12.825 2.0625 9 2.0625Z"
        fill="#55B938"
      />
      <path
        d="M7.93496 11.6852C7.78496 11.6852 7.64246 11.6252 7.53746 11.5202L5.41496 9.3977C5.19746 9.1802 5.19746 8.8202 5.41496 8.6027C5.63246 8.3852 5.99246 8.3852 6.20996 8.6027L7.93496 10.3277L11.79 6.4727C12.0075 6.2552 12.3675 6.2552 12.585 6.4727C12.8025 6.6902 12.8025 7.05019 12.585 7.26769L8.33246 11.5202C8.22746 11.6252 8.08496 11.6852 7.93496 11.6852Z"
        fill="#55B938"
      />
    </svg>
  );
}
export function LinkGenerated() {
  return (
    <svg
      width="1.25vw"
      height="1.25vw"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.74251 16.1248C5.49751 16.1248 4.24501 15.6523 3.29251 14.6998C1.39501 12.7948 1.39501 9.70484 3.29251 7.80734C3.51001 7.58984 3.87001 7.58984 4.08751 7.80734C4.30501 8.02484 4.30501 8.38484 4.08751 8.60234C2.62501 10.0648 2.62501 12.4423 4.08751 13.9048C5.55001 15.3673 7.92751 15.3673 9.39001 13.9048C10.095 13.1998 10.485 12.2548 10.485 11.2498C10.485 10.2523 10.095 9.30734 9.39001 8.59484C9.17251 8.37734 9.17251 8.01734 9.39001 7.79984C9.60751 7.58234 9.96751 7.58234 10.185 7.79984C11.1075 8.72234 11.61 9.94484 11.61 11.2498C11.61 12.5548 11.1 13.7773 10.185 14.6998C9.24001 15.6523 7.99501 16.1248 6.74251 16.1248Z"
        fill="#0088FA"
      />
      <path
        d="M14.3024 10.6202C14.1599 10.6202 14.0174 10.5677 13.9049 10.4552C13.6874 10.2377 13.6874 9.87768 13.9049 9.66018C15.4424 8.12268 15.4424 5.62518 13.9049 4.09518C12.3674 2.55768 9.86994 2.55768 8.33994 4.09518C7.59744 4.83768 7.18494 5.82768 7.18494 6.87768C7.18494 7.92768 7.59744 8.91768 8.33994 9.66018C8.55744 9.87768 8.55744 10.2377 8.33994 10.4552C8.12244 10.6727 7.76244 10.6727 7.54494 10.4552C6.59244 9.50268 6.05994 8.22768 6.05994 6.87768C6.05994 5.52768 6.58494 4.25268 7.54494 3.30018C9.51744 1.32768 12.7274 1.32768 14.7074 3.30018C16.6799 5.27268 16.6799 8.49018 14.7074 10.4627C14.5949 10.5677 14.4449 10.6202 14.3024 10.6202Z"
        fill="#0088FA"
      />
    </svg>
  );
}
export function LinkExpired() {
  return (
    <svg
      width="1.25vw"
      height="1.25vw"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 11.0625C8.6925 11.0625 8.4375 10.8075 8.4375 10.5V6.75C8.4375 6.4425 8.6925 6.1875 9 6.1875C9.3075 6.1875 9.5625 6.4425 9.5625 6.75V10.5C9.5625 10.8075 9.3075 11.0625 9 11.0625Z"
        fill="#395C85"
      />
      <path
        d="M9 13.4999C8.955 13.4999 8.9025 13.4924 8.85 13.4849C8.805 13.4774 8.76 13.4624 8.715 13.4399C8.67 13.4249 8.625 13.4024 8.58 13.3724C8.5425 13.3424 8.505 13.3124 8.4675 13.2824C8.3325 13.1399 8.25 12.9449 8.25 12.7499C8.25 12.5549 8.3325 12.3599 8.4675 12.2174C8.505 12.1874 8.5425 12.1574 8.58 12.1274C8.625 12.0974 8.67 12.0749 8.715 12.0599C8.76 12.0374 8.805 12.0224 8.85 12.0149C8.9475 11.9924 9.0525 11.9924 9.1425 12.0149C9.195 12.0224 9.24 12.0374 9.285 12.0599C9.33 12.0749 9.375 12.0974 9.42 12.1274C9.4575 12.1574 9.495 12.1874 9.5325 12.2174C9.6675 12.3599 9.75 12.5549 9.75 12.7499C9.75 12.9449 9.6675 13.1399 9.5325 13.2824C9.495 13.3124 9.4575 13.3424 9.42 13.3724C9.375 13.4024 9.33 13.4249 9.285 13.4399C9.24 13.4624 9.195 13.4774 9.1425 13.4849C9.0975 13.4924 9.045 13.4999 9 13.4999Z"
        fill="#395C85"
      />
      <path
        d="M13.545 16.6199H4.45498C2.99248 16.6199 1.87498 16.0874 1.30498 15.1274C0.742482 14.1674 0.817482 12.9299 1.52998 11.6474L6.07498 3.47238C6.82498 2.12238 7.85998 1.37988 8.99998 1.37988C10.14 1.37988 11.175 2.12238 11.925 3.47238L16.47 11.6549C17.1825 12.9374 17.265 14.1674 16.695 15.1349C16.125 16.0874 15.0075 16.6199 13.545 16.6199ZM8.99998 2.50488C8.29498 2.50488 7.60498 3.04488 7.05748 4.01988L2.51998 12.2024C2.00998 13.1174 1.92748 13.9574 2.27998 14.5649C2.63248 15.1724 3.41248 15.5024 4.46248 15.5024H13.5525C14.6025 15.5024 15.375 15.1724 15.735 14.5649C16.095 13.9574 16.005 13.1249 15.495 12.2024L10.9425 4.01988C10.395 3.04488 9.70498 2.50488 8.99998 2.50488Z"
        fill="#395C85"
      />
    </svg>
  );
}
export function Refresh({ size, color }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 17.0625C5.1 17.0625 1.935 13.89 1.935 9.99748C1.935 8.59498 2.3475 7.23748 3.1275 6.06748C3.3 5.81248 3.6525 5.73748 3.9075 5.90998C4.1625 6.08248 4.2375 6.43498 4.065 6.68998C3.4125 7.66498 3.0675 8.81248 3.0675 9.98998C3.0675 13.2675 5.73 15.93 9.0075 15.93C12.285 15.93 14.9475 13.2675 14.9475 9.98998C14.9475 6.71248 12.2775 4.04998 9 4.04998C8.31 4.04998 7.635 4.14748 6.9975 4.34248C6.6975 4.43248 6.3825 4.26748 6.2925 3.96748C6.2025 3.66748 6.3675 3.35248 6.6675 3.26248C7.4175 3.03748 8.1975 2.91748 9 2.91748C12.9 2.91748 16.065 6.08998 16.065 9.98248C16.065 13.875 12.9 17.0625 9 17.0625Z"
        fill={color}
      />
      <path
        d="M5.90253 4.55259C5.77503 4.55259 5.64003 4.50759 5.53503 4.41759C5.29503 4.20759 5.27253 3.85509 5.47503 3.62259L7.64252 1.13259C7.84502 0.900091 8.20503 0.870091 8.43753 1.08009C8.67003 1.28259 8.69252 1.64259 8.49003 1.87509L6.32253 4.35759C6.21003 4.48509 6.05253 4.55259 5.90253 4.55259Z"
        fill={color}
      />
      <path
        d="M8.43 6.39759C8.3175 6.39759 8.1975 6.36009 8.1 6.29259L5.565 4.44009C5.3175 4.26009 5.265 3.90759 5.445 3.66009C5.625 3.40509 5.9775 3.35259 6.2325 3.53259L8.76 5.37759C9.0075 5.55759 9.0675 5.91009 8.88 6.16509C8.775 6.32259 8.6025 6.39759 8.43 6.39759Z"
        fill={color}
      />
    </svg>
  );
}
Refresh.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
Refresh.defaultProps = {
  color: '#2179C4',
  size: '1.25vw',
};
export function ClockIcon() {
  return (
    <svg
      width="1.111vw"
      height="1.111vw"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00004 15.1666C4.04671 15.1666 0.833374 11.9533 0.833374 7.99992C0.833374 4.04659 4.04671 0.833252 8.00004 0.833252C11.9534 0.833252 15.1667 4.04659 15.1667 7.99992C15.1667 11.9533 11.9534 15.1666 8.00004 15.1666ZM8.00004 1.83325C4.60004 1.83325 1.83337 4.59992 1.83337 7.99992C1.83337 11.3999 4.60004 14.1666 8.00004 14.1666C11.4 14.1666 14.1667 11.3999 14.1667 7.99992C14.1667 4.59992 11.4 1.83325 8.00004 1.83325Z"
        fill="#2179C4"
      />
      <path
        d="M10.4734 10.6199C10.3867 10.6199 10.3001 10.5999 10.2201 10.5466L8.1534 9.31326C7.64007 9.00659 7.26007 8.33326 7.26007 7.73992V5.00659C7.26007 4.73326 7.48674 4.50659 7.76007 4.50659C8.0334 4.50659 8.26007 4.73326 8.26007 5.00659V7.73992C8.26007 7.97992 8.46007 8.33326 8.66674 8.45326L10.7334 9.68659C10.9734 9.82659 11.0467 10.1333 10.9067 10.3733C10.8067 10.5333 10.6401 10.6199 10.4734 10.6199Z"
        fill="#2179C4"
      />
    </svg>
  );
}
export function KnowMore() {
  return (
    <svg
      width="1.111vw"
      height="1.111vw"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33337 14.88C5.14671 14.88 4.95336 14.8334 4.78003 14.74C4.40003 14.54 4.16671 14.14 4.16671 13.7133V12.7667C2.15337 12.5601 0.833374 11.08 0.833374 8.96V4.96004C0.833374 2.66671 2.37337 1.12671 4.66671 1.12671H11.3334C13.6267 1.12671 15.1667 2.66671 15.1667 4.96004V8.96C15.1667 11.2533 13.6267 12.7933 11.3334 12.7933H8.82003L5.98002 14.6867C5.78669 14.8134 5.56004 14.88 5.33337 14.88ZM4.66671 2.12004C2.94671 2.12004 1.83337 3.23337 1.83337 4.95337V8.95341C1.83337 10.6734 2.94671 11.7867 4.66671 11.7867C4.94004 11.7867 5.16671 12.0134 5.16671 12.2867V13.7067C5.16671 13.7934 5.22004 13.8334 5.25338 13.8534C5.28671 13.8734 5.35338 13.8934 5.42672 13.8467L8.39339 11.8734C8.47339 11.8201 8.57338 11.7867 8.67338 11.7867H11.34C13.06 11.7867 14.1734 10.6734 14.1734 8.95341V4.95337C14.1734 3.23337 13.06 2.12004 11.34 2.12004H4.66671Z"
        fill="#2179C4"
      />
      <path
        d="M7.99984 8.07324C7.7265 8.07324 7.49984 7.84658 7.49984 7.57324V7.43327C7.49984 6.65993 8.06649 6.27993 8.27983 6.13326C8.52649 5.96659 8.60649 5.85327 8.60649 5.67993C8.60649 5.3466 8.33317 5.07324 7.99984 5.07324C7.6665 5.07324 7.39319 5.3466 7.39319 5.67993C7.39319 5.95327 7.16652 6.17993 6.89319 6.17993C6.61986 6.17993 6.39319 5.95327 6.39319 5.67993C6.39319 4.79326 7.11317 4.07324 7.99984 4.07324C8.8865 4.07324 9.60649 4.79326 9.60649 5.67993C9.60649 6.43993 9.04651 6.81992 8.83984 6.95992C8.57984 7.13325 8.49984 7.2466 8.49984 7.43327V7.57324C8.49984 7.85324 8.27317 8.07324 7.99984 8.07324Z"
        fill="#2179C4"
      />
      <path
        d="M8 9.7334C7.72 9.7334 7.5 9.50673 7.5 9.2334C7.5 8.96007 7.72667 8.7334 8 8.7334C8.27333 8.7334 8.5 8.96007 8.5 9.2334C8.5 9.50673 8.28 9.7334 8 9.7334Z"
        fill="#2179C4"
      />
    </svg>
  );
}
export function DataDownloadHistory() {
  return (
    <svg
      width="1.667vw"
      height="1.667vw"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 10C2.34315 10 1 11.3431 1 13V20C1 21.6569 2.34315 23 4 23H20C21.6569 23 23 21.6569 23 20V13C23 11.3431 21.6569 10 20 10H4Z"
        fill="url(#paint0_linear_25321_111371)"
      />
      <path
        d="M11 15.5857L7.70711 12.2928C7.31658 11.9023 6.68342 11.9023 6.29289 12.2928C5.90237 12.6834 5.90237 13.3165 6.29289 13.7071L11.2929 18.7071C11.6834 19.0976 12.3166 19.0976 12.7071 18.7071L17.7071 13.7071C18.0976 13.3165 18.0976 12.6834 17.7071 12.2928C17.3166 11.9023 16.6834 11.9023 16.2929 12.2928L13 15.5857V2C13 1.44771 12.5523 1 12 1C11.4477 1 11 1.44771 11 2V15.5857Z"
        fill="#850026"
      />
      <defs>
        <linearGradient
          id="paint0_linear_25321_111371"
          x1="4.80596e-09"
          y1="9.409"
          x2="12.423"
          y2="30.432"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.083" stop-color="#FF6A6A" />
          <stop offset="1" stop-color="#F72257" />
        </linearGradient>
      </defs>
    </svg>
  );
}
export function EmailAlertIcon() {
  return (
    <svg
      width="1.667vw"
      height="1.25vw"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M21.6096 2.88062H0V17.4145H21.6096V2.88062Z" fill="#FFC970" />
      <path
        d="M20.3521 17.4144L10.8047 6.18408L1.25732 17.4144H20.3521Z"
        fill="#FFB233"
      />
      <path
        d="M10.8048 7.66138L19.4581 17.4144H2.15137L10.8048 7.66138Z"
        fill="#FFC970"
      />
      <path
        d="M10.8048 13.8766L0 4.12364V2.88062H21.6096V4.12364L10.8048 13.8766Z"
        fill="#FFB233"
      />
      <path
        d="M10.8048 12.6336L0 2.88062H21.6096L10.8048 12.6336Z"
        fill="#FFDCA3"
      />
      <path
        d="M16.3506 3.93241C16.3506 6.3085 18.2773 8.2352 20.6534 8.2352C20.9833 8.2352 21.3036 8.19695 21.6095 8.13002V2.88062H16.4797C16.3936 3.21528 16.3506 3.56906 16.3506 3.93241Z"
        fill="#FFB233"
      />
      <path
        d="M16.4797 2.88062C16.3936 3.21528 16.3506 3.56906 16.3506 3.93241C16.3506 4.98898 16.7331 5.9595 17.3689 6.7101L21.6095 2.88062H16.4797Z"
        fill="#FFC970"
      />
      <path
        d="M20.6534 7.27892C22.5017 7.27892 24 5.78059 24 3.93231C24 2.08402 22.5017 0.585693 20.6534 0.585693C18.8051 0.585693 17.3068 2.08402 17.3068 3.93231C17.3068 5.78059 18.8051 7.27892 20.6534 7.27892Z"
        fill="#D84861"
      />
      <path
        d="M22.3458 1.04468C22.6375 1.54189 22.8048 2.12037 22.8048 2.73711C22.8048 4.58731 21.3084 6.08372 19.4582 6.08372C18.8414 6.08372 18.263 5.91639 17.7657 5.62476C18.349 6.6144 19.4199 7.27894 20.6534 7.27894C22.5036 7.27894 24 5.78253 24 3.93233C24 2.70364 23.3355 1.62794 22.3458 1.04468Z"
        fill="#C12944"
      />
      <path
        d="M19.4582 4.41033C20.3824 4.41033 21.1315 3.66117 21.1315 2.73703C21.1315 1.81289 20.3824 1.06372 19.4582 1.06372C18.5341 1.06372 17.7849 1.81289 17.7849 2.73703C17.7849 3.66117 18.5341 4.41033 19.4582 4.41033Z"
        fill="#E17084"
      />
      <path
        d="M20.6534 6.5617C19.2048 6.5617 18.0239 5.38082 18.0239 3.93222C18.0239 3.21987 18.3012 2.55533 18.8128 2.05812C19.3195 1.56091 19.9889 1.29318 20.7012 1.30274C21.404 1.31708 22.0638 1.60393 22.5514 2.12027C23.0438 2.6366 23.302 3.31071 23.2781 4.01828C23.259 4.63501 23.0247 5.22784 22.6183 5.68202C22.4176 5.90672 22.1116 5.98322 21.8295 5.87326C21.5474 5.76808 21.3658 5.50513 21.3658 5.20393V5.12744H20.6486C19.9889 5.12744 19.4534 4.59198 19.4534 3.93222C19.4534 3.27246 19.9889 2.737 20.6486 2.737C21.3084 2.737 21.8438 3.27246 21.8438 3.93222V5.20393C21.8438 5.35692 21.9634 5.41429 21.9968 5.42863C22.0351 5.44298 22.1594 5.47644 22.2598 5.36648C22.5897 4.99357 22.7809 4.51071 22.8 4.00393C22.8191 3.42545 22.604 2.87565 22.2024 2.45015C21.8008 2.02943 21.2606 1.79039 20.6869 1.78083C20.1036 1.77126 19.5538 1.99118 19.1427 2.39756C18.7267 2.80393 18.4972 3.34895 18.4972 3.93222C18.4972 5.11788 19.463 6.08361 20.6486 6.08361V6.5617H20.6534ZM20.6534 3.21509C20.2566 3.21509 19.9363 3.53541 19.9363 3.93222C19.9363 4.32903 20.2566 4.64935 20.6534 4.64935H21.3705V3.93222C21.3705 3.53541 21.0502 3.21509 20.6534 3.21509Z"
        fill="#FFC970"
      />
    </svg>
  );
}
